<template>
    <v-dialog v-if="dialog" v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title>
                <h2 class="title">{{ title }}</h2>
            </v-card-title>

            <div v-if="loading" class="my-3 px-6">
                <v-progress-linear
                        :indeterminate="loading"
                        :class="{ 'no-opacity': !loading }"
                        style="height: 2px;"
                ></v-progress-linear>
            </div>
            <template v-else>
                <v-card-text class="mt-5">
                    <div>
                        <div class="px-2">
                            <template v-if="organizationData.active === 0">
                                <v-text-field
                                    v-model="preparedData.name"
                                    label="Name"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.name) || server_errors.name"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.first_name"
                                    label="Contact First Name"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.first_name) || server_errors.first_name"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.last_name"
                                    label="Contact Last Name"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.last_name) || server_errors.last_name"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.facebook"
                                    label="Facebook"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.facebook) || server_errors.facebook"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.twitter"
                                    label="Twitter"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.twitter) || server_errors.twitter"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.pinterest"
                                    label="Pinterest"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.pinterest) || server_errors.pinterest"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.youtube"
                                    label="Youtube"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.youtube) || server_errors.youtube"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.instagram"
                                    label="Instagram"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.instagram) || server_errors.instagram"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.linkedin"
                                    label="Linkedin"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.linkedin) || server_errors.linkedin"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-autocomplete
                                    :items="organizationData.category_projects"
                                    label="Projects"
                                    :item-text="item => decodeHTMLEntities(item.name)"
                                    item-value="id"
                                    class="mb-3"
                                    multiple
                                    v-model="preparedData.organization_projects"
                                    :error-messages="server_errors.category_ids"
                                    placeholder="Please Select"
                                    @focus="resetServerValidation"
                                ></v-autocomplete>
                                <v-autocomplete
                                    :items="organizationData.topics"
                                    label="Topics"
                                    :item-text="item => decodeHTMLEntities(item.name)"
                                    item-value="id"
                                    class="mb-3"
                                    multiple
                                    v-model="preparedData.organization_topics"
                                    :error-messages="server_errors.category_ids"
                                    placeholder="Please Select"
                                    @focus="resetServerValidation"
                                ></v-autocomplete>
                                <v-checkbox
                                    v-model="preparedData.global"
                                    label="Global Advertiser"
                                    :error-messages="server_errors.global"
                                    @focus="resetServerValidation"
                                ></v-checkbox>
                            </template>
                            <template v-else-if="organizationData.active === 1">
                                <div class="body-2 mb-5">
                                    This information will be used for your Product Finder profile on ConcreteDecor.net
                                </div>
                                <v-file-input
                                    id="image"
                                    accept="image/png, image/jpeg, image/jpg"
                                    ref="file"
                                    name="image"
                                    show-size
                                    class="mb-3"
                                    label="Upload Company Logo"
                                    placeholder="Please Select"
                                    :error-messages="server_errors.image"
                                    @change="handleFileUploads"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Upload the logo you would like used for your Product Finder profile. Ensure that image is not smaller than 160x160px.</div>
                                    </v-tooltip>
                                </v-file-input>
                                <v-textarea
                                    v-model="preparedData.description"
                                    label="Company Description"
                                    auto-grow
                                    rows="1"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.description) || server_errors.description"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the description you would like used for your Product Finder profile. (100 words or less)</div>
                                    </v-tooltip>
                                </v-textarea>
                                <v-text-field
                                    v-model="preparedData.company_email"
                                    label="Company Email"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.company_email) || server_errors.company_email"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide the email address you would like used for your Product Finder profile. This will be publically shared and should be for the department that handles product inquiries.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.company_phone"
                                    label="Company Phone"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="server_errors.company_phone"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide the phone number you would like used for your Product Finder profile. This will be publically shared and should be for the department that handles product inquiries.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.address"
                                    label="Company Address"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.address) || server_errors.address"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the address you would like used for your Product Finder profile.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.city"
                                    label="City"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.city) || server_errors.city"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the city you would like used for your Product Finder profile.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-autocomplete
                                    :items="countries"
                                    label="Country"
                                    item-text="name"
                                    item-value="id"
                                    class="mb-3"
                                    v-model="preparedData.country_id"
                                    @change="checkState"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.preparedData.country_id) || server_errors.country_id"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the country you would like used for your Product Finder profile. (If you do not see your country available, please contact us.)</div>
                                    </v-tooltip>
                                </v-autocomplete>
                                <v-autocomplete
                                    :items="filteredStates"
                                    label="State"
                                    item-text="name"
                                    item-value="id"
                                    class="mb-3"
                                    v-model="preparedData.state_id"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.preparedData.state_id) || server_errors.state_id"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the state you would like used for your Product Finder profile.</div>
                                    </v-tooltip>
                                </v-autocomplete>
                                <v-text-field
                                    v-model="preparedData.website"
                                    class="mb-3"
                                    label="Website"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.website) || server_errors.website"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide a URL that will take users to the product information on your website. (https://www.example.com/)</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.where_to_buy_url"
                                    class="mb-3"
                                    label="Where to Buy URL"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.where_to_buy_url) || server_errors.where_to_buy_url"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide a URL that will take users to the Shop section on your website. (https://www.example.com/)</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-autocomplete
                                    :items="organizationData.category_products"
                                    label="Choose the product categories your company offers"
                                    :item-text="item => decodeHTMLEntities(item.name)"
                                    item-value="id"
                                    class="mb-3"
                                    multiple
                                    :counter="organizationData.organization.product_categories"
                                    v-model="preparedData.organization_products"
                                    :error-messages="errors($v.preparedData.organization_products) || server_errors.category_ids"
                                    placeholder="Please Select"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Choose the product categories that your company offers. If you need additional product categories than what you have been allotted, please contact us for upgrades.</div>
                                    </v-tooltip>
                                </v-autocomplete>
                            </template>
                            <template v-else-if="organizationData.active === 2">
                                <div class="body-2 mb-5">
                                    This information will be used for your Training &amp; Event Calendar profile on ConcreteDecor.net
                                </div>
                                <v-text-field
                                    v-model="preparedData.trainings_name"
                                    label="Company Name"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.trainings_name) || server_errors.trainings_name"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the company name you would like used for your Training &amp; Event Calendar profile.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-file-input
                                    id="image"
                                    accept="image/png, image/jpeg, image/jpg"
                                    ref="file"
                                    name="image"
                                    class="mb-3"
                                    show-size
                                    label="Upload Company Logo"
                                    placeholder="Please Select"
                                    :error-messages="server_errors.trainings_image"
                                    @change="handleFileUploads"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Upload the logo you would like used for your Training &amp; Event Calendar profile.</div>
                                    </v-tooltip>
                                </v-file-input>
                                <v-textarea
                                    v-model="preparedData.trainings_description"
                                    label="Company Description"
                                    class="mb-3"
                                    auto-grow
                                    rows="1"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.trainings_description) || server_errors.trainings_description"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the description you would like used for your Training &amp; Event Calendar profile. (150 words or less)</div>
                                    </v-tooltip>
                                </v-textarea>
                                <v-text-field
                                    v-model="preparedData.trainings_email"
                                    label="Company Email"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.trainings_email) || server_errors.trainings_email"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide the email address you would like used for your Training &amp; Event Calendar profile. This will be publically shared and should be for the department that handles training inquiries.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.trainings_phone"
                                    label="Company Phone"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="server_errors.trainings_phone"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide the phone number you would like used for your Training &amp; Event Calendar profile. This will be publically shared and should be for the department that handles training inquiries.</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.trainings_address"
                                    label="Address"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.trainings_address) || server_errors.trainings_address"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the address you would like used for your Training &amp; Event Calendar profile.
                                        (You will be able to list specific addresses for your individual courses.)
                                        </div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-text-field
                                    v-model="preparedData.trainings_city"
                                    label="City"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.trainings_city) || server_errors.trainings_city"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the city you would like used for your Training &amp; Event Calendar profile. (You will be able to list specific addresses for your individual courses.)</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-autocomplete
                                    :items="countries"
                                    label="Country"
                                    item-text="name"
                                    item-value="id"
                                    class="mb-3"
                                    v-model="preparedData.trainings_country_id"
                                    @change="checkTrainingState"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.preparedData.trainings_country_id) || server_errors.trainings_country_id"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the country you would like used for your Training &amp; Event Calendar profile. (If you do not see your country available, please contact us.)</div>
                                    </v-tooltip>
                                </v-autocomplete>
                                <v-autocomplete
                                    :items="filteredTrainingsStates"
                                    label="State"
                                    item-text="name"
                                    item-value="id"
                                    class="mb-3"
                                    v-model="preparedData.trainings_state_id"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.preparedData.trainings_state_id) || server_errors.trainings_state_id"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Enter the state you would like used for your Training &amp; Event Calendar profile. (You will be able to list specific addresses for your individual courses.)</div>
                                    </v-tooltip>
                                </v-autocomplete>
                                <v-text-field
                                    v-model="preparedData.trainings_website"
                                    label="Training Website"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.trainings_website) || server_errors.trainings_website"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide a URL that will take users to your training information on your website. (https://www.example.com/)</div>
                                    </v-tooltip>
                                </v-text-field>
                                <v-autocomplete
                                    :items="organizationData.trainings"
                                    label="Choose the training categories your company offers"
                                    :item-text="item => decodeHTMLEntities(item.name)"
                                    item-value="id"
                                    class="mb-3"
                                    multiple
                                    :counter="organizationData.organization.trainings_guide_categories"
                                    v-model="preparedData.organization_trainings"
                                    :error-messages="errors($v.preparedData.organization_trainings) || server_errors.category_ids"
                                    placeholder="Please Select"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Choose the categories that your company offers training in. If you need additional training categories than what you have been allotted, please contact us for upgrades.</div>
                                    </v-tooltip>
                                </v-autocomplete>
                            </template>
                        </div>
                        <v-alert class="pa-2 mt-3" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                            <span class="caption">Please fill out form correctly</span>
                        </v-alert>
                        <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                                 transition="scale-transition">
                            <span class="caption">{{ serverValidationMessage }}</span>
                        </v-alert>
                    </div>
                </v-card-text>

                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                    <v-btn
                            color="primary"
                            :disabled="loadingSave"
                            :loading="loadingSave"
                            @click="CompanyEdit"
                    >Save
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from "vuelidate"
    import { required, email, maxLength, helpers, url } from "vuelidate/lib/validators"
    import { valMessages, getValMessage } from "@/common/error-messages"

    let validations = {};

    export default {
        name: 'CompanyEdit',
        mixins: [validationMixin],
        validations() {
            validations = {
                preparedData: {}
            };
            if (this.organizationData.active === 0) {
                validations.preparedData.name = { required, noSlash: v => !helpers.req(v) || !v.includes('/')}
                validations.preparedData.first_name = { required, noSlash: v => !helpers.req(v) || !v.includes('/')}
                validations.preparedData.last_name = { required, noSlash: v => !helpers.req(v) || !v.includes('/')}
                validations.preparedData.facebook = { url }
                validations.preparedData.twitter = { url }
                validations.preparedData.pinterest = { url }
                validations.preparedData.youtube = { url }
                validations.preparedData.instagram = { url }
                validations.preparedData.linkedin = { url }
            } else if (this.organizationData.active === 1) {
                validations.preparedData.company_email = { email }
                validations.preparedData.state_id = { required }
                validations.preparedData.country_id = { required }
                validations.preparedData.city = { required }
                validations.preparedData.address = { required }
                validations.preparedData.description = { required }
                validations.preparedData.website = { url }
                validations.preparedData.where_to_buy_url = { url }
                validations.preparedData.organization_products = { arrayMaxLen: maxLength(Number(this.organizationData.organization.product_categories)) }
            } else if (this.organizationData.active === 2) {
                validations.preparedData.trainings_email = { email }
                validations.preparedData.trainings_name = { required }
                validations.preparedData.trainings_state_id = { required }
                validations.preparedData.trainings_country_id = { required }
                validations.preparedData.trainings_city = { required }
                validations.preparedData.trainings_address = { required }
                validations.preparedData.trainings_description = { required }
                validations.preparedData.trainings_website = { url }
                validations.preparedData.organization_trainings = { arrayMaxLen: maxLength(Number(this.organizationData.organization.trainings_guide_categories)) }
            }
            this.errors = getValMessage(valMessages)(validations);
            return validations;
        },
        data: () => ({
            no_data: [null, "", undefined, "null"],
            preparedData: {},
            organizationData: {},
            states: [],
            countries: [],
            category_projects: [],
            category_products: [],
            topics: [],
            trainings: [],
            title: null,
            loading: false,
            loadingSave: false,
            loadingBannerTypes: false,
            dialog: false,
            file: null,
            selectedFileHeight: null,
            selectedFileWidth: null,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('EditOrganization', this.openModal)
            this.getStates()
            this.getCountries()
            this.getProductCategories()
            this.getProjectCategories()
            this.getPostTopics()
            this.getTrainingCategories()
        },
        beforeDestroy() {
            this.$root.$off('EditOrganization', this.openModal)
        },
        methods: {
            openModal(input) {
                this.organizationData = input
                this.organizationData.category_projects = this.category_projects
                this.organizationData.category_products = this.category_products
                this.organizationData.topics = this.topics
                this.organizationData.trainings = this.trainings
                this.organizationData.organization.organization_projects = this.organizationData.organization_projects.map(i => i.id)
                this.organizationData.organization.organization_products = this.organizationData.organization_products.map(i => i.id)
                this.organizationData.organization.organization_topics = this.organizationData.organization_topics.map(i => i.id)
                this.organizationData.organization.organization_trainings = this.organizationData.organization_trainings.map(i => i.id)
                if (this.organizationData.active === 0) { this.title = 'Edit General Info'}
                else if (this.organizationData.active === 1) { this.title = 'Edit Product Finder Profile'}
                else if (this.organizationData.active === 2) { this.title = 'Edit Training & Event Calendar Profile'}
                this.file = null
                this.preparedData = _.cloneDeep(this.organizationData.organization)
                this.preparedData.state_id ? this.preparedData.state_id = Number(this.preparedData.state_id) : null
                if(!this.no_data.includes(this.preparedData.user) && !this.no_data.includes(this.preparedData.user.first_name)) {
                    this.preparedData.first_name = this.preparedData.user.first_name
                } else {
                    this.preparedData.first_name = ''
                }
                if(!this.no_data.includes(this.preparedData.user) && !this.no_data.includes(this.preparedData.user.last_name)) {
                    this.preparedData.last_name = this.preparedData.user.last_name
                } else {
                    this.preparedData.last_name = ''
                }
                this.$v.$reset()
                this.resetServerValidation()
                this.dialog = true
            },
            getStates() {
                this.loading = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/states")
                        .then(response => {
                            let data = response.data;
                            this.states = data.states
                            this.loading = false;
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.loading = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getCountries() {
                return new Promise((resolve, reject) => {
                    ApiService.get("/countries")
                        .then(response => {
                            let data = response.data;
                            this.countries = data.countries
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getProductCategories() {
                return new Promise((resolve, reject) => {
                    ApiService.get("/categories/show_products")
                        .then(response => {
                            let data = response.data;
                            this.category_products = data.categories
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getProjectCategories() {
                return new Promise((resolve, reject) => {
                    ApiService.get("/categories/show_type_of_product")
                        .then(response => {
                            let data = response.data;
                            this.category_projects = data.categories
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getPostTopics() {
                return new Promise((resolve, reject) => {
                    ApiService.get("/categories/show_topics")
                        .then(response => {
                            let data = response.data;
                            this.topics = data.categories
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getTrainingCategories() {
                return new Promise((resolve, reject) => {
                    ApiService.get("/categories/show_training")
                        .then(response => {
                            let data = response.data;
                            this.trainings = data.categories
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            CompanyEdit() {
                this.resetServerValidation()
                this.$v.preparedData.$touch()
                if (!this.$v.preparedData.$invalid) {
                    this.loadingSave = true
                    let body = _.cloneDeep(this.preparedData)
                    if ( this.organizationData.active === 0 ) {
                        body.edit_tab = "general"
                    } else if ( this.organizationData.active === 1 ) {
                        body.edit_tab = "product"
                        if ( this.file ) { body.image = this.file }
                    } else if ( this.organizationData.active === 2 ) {
                        body.edit_tab = "training"
                        if ( this.file ) { body.trainings_image = this.file }
                    }
                    body.category_ids = [...body.organization_projects, ...body.organization_products, ...body.organization_topics, ...body.organization_trainings].join(',')
                    delete body.organization_projects
                    delete body.organization_products
                    delete body.organization_topics
                    delete body.organization_trainings
                    if(body.state_id) { body.state = this.states.find(i => i.id === body.state_id).name } else { body.state_id = null }
                    if(body.country_id) { body.country = this.countries.find(i => i.id === body.country_id).name } else { body.country_id = null }
                    if(body.trainings_state_id) { body.trainings_state = this.states.find(i => i.id === body.trainings_state_id).name } else { body.trainings_state_id = null }
                    if(body.trainings_country_id) { body.trainings_country = this.countries.find(i => i.id === body.trainings_country_id).name } else { body.trainings_country_id = null }

                    ApiService.put('/admin/organization/'+this.organizationData.organization.id+'/update', body)
                        .then(response => {
                            this.$root.$emit("notification", {
                                status: "success",
                                text: `Advertiser has been successfully updated`
                            });
                            this.loadingSave = false
                            this.$emit('done')
                            this.closeModal()
                        })
                        .catch(({response}) => {
                            this.loadingSave = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            if (response.data.message) {
                                this.serverValidationMessage = response.data.message;
                            }
                            if (response.data.errors) {
                                this.server_errors = response.data.errors;
                            }
                        });
                }
            },
            closeModal() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
            handleFileUploads(event) {
                let image = event;

                let imageFile = new Image()

                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.file = e.target.result
                    imageFile.src = e.target.result
                }

                imageFile.onload = function () {
                    this.selectedFileHeight = this.height;
                    this.selectedFileWidth = this.width;
                };
            },
            decodeHTMLEntities(i) {
                return _.unescape(i)
            },
            checkState () {
                if(this.preparedData.country_id && this.preparedData.state_id) {
                    if(this.states.find(i => i.id === this.preparedData.state_id).country_id !== this.preparedData.country_id) {
                        this.preparedData.state_id = null
                    }
                }
            },
            checkTrainingState () {
                if(this.preparedData.trainings_country_id && this.preparedData.trainings_state_id) {
                    if(this.states.find(i => i.id === this.preparedData.trainings_state_id).country_id !== this.preparedData.trainings_country_id) {
                        this.preparedData.trainings_state_id = null
                    }
                }
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
            filteredStates: function () {
                return this.states.filter(i => {
                    if(this.preparedData.country_id) { return Number(i.country_id) === Number(this.preparedData.country_id) }
                    else { return true }
                })
            },
            filteredTrainingsStates: function () {
                return this.states.filter(i => {
                    if(this.preparedData.trainings_country_id) { return Number(i.country_id) === Number(this.preparedData.trainings_country_id) }
                    else { return true }
                })
            }
        }
    }
</script>
